import { render, staticRenderFns } from "./StartFixedPriceAccountModal.vue?vue&type=template&id=0395ca16&scoped=true&"
import script from "./StartFixedPriceAccountModal.vue?vue&type=script&lang=ts&"
export * from "./StartFixedPriceAccountModal.vue?vue&type=script&lang=ts&"
import style0 from "./StartFixedPriceAccountModal.vue?vue&type=style&index=0&id=0395ca16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0395ca16",
  null
  
)

/* custom blocks */
import block0 from "./StartFixedPriceAccountModal.json?vue&type=custom&index=0&blockType=i18n&issuerPath=D%3A%5Ca%5C1%5Cs%5Ccomponents%5Ccompany%5CStartFixedPriceAccountModal.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCheckbox,VDialog,VIcon,VSpacer})
